import { useBILogger } from '@wix/fe-essentials-standalone';
import { useEffect, useRef } from 'react';
import { biLogger } from './biLogger';
import { ReportProps } from '@wix/web-bi-logger/dist/src/types';

/**
 * Initializes the biLogger singleton with the BI logger instance from fe-essentials.
 * This hook should be called once at the app root level (e.g., in AppLayout).
 * Components and actions should use the biLogger singleton directly instead of this hook.
 */
export function useBiLogger() {
  const bi = useBILogger();
  const biRef = useRef(bi);

  // Keep biRef.current updated with the latest bi instance
  biRef.current = bi;

  useEffect(() => {
    biLogger.initialize({
      report: (payload: ReportProps) => {
        const action = `${payload.src}:${payload.evid}`;
        console.debug(`bi report ${action}`, payload.params);
        return biRef.current.report(payload);
      },
    });
  }, []);
}
